import { Renderer } from '../renderer';
import type { GameRenderer,RenderSnapshot,RenderFrame } from '../RendererInterface';
export class ClassicRenderer implements GameRenderer {
  readonly mode='classic';
  private renderer:Renderer;
  constructor(canvas:HTMLCanvasElement){this.renderer=new Renderer(canvas);}
  draw(snapshot:RenderSnapshot,frame:RenderFrame):void{this.renderer.draw(snapshot,frame.title,frame.wallTime);}
  events():void{}configure():void{}suspend():void{}resume():void{}dispose():void{}
}
